import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Vendedor } from '../models/vendedor';

@Injectable({
  providedIn: 'root',
})
export class VendedorService {

  private url = `${environment.apiUrl}/vendedores`;

  constructor(private http: HttpClient) {}

  selecionar(): Observable<Vendedor[]> {
    return this.http.get<Vendedor[]>(this.url);
  }

  cadastrar(obj: Vendedor): Observable<Vendedor> {
    // Constrói um payload compatível com VendedorDto do backend:
    // - inclui usuarioId (se houver)
    // - remove a propriedade 'usuario' para evitar enviar o objeto completo
    const payload: any = { ...obj };
    if (obj.usuario && (obj.usuario as any).id) {
      payload.usuarioId = (obj.usuario as any).id;
    }
    delete payload.usuario;
    return this.http.post<Vendedor>(this.url, payload);
  }

  alterar(id: number, obj: Vendedor): Observable<Vendedor> {
    return this.http.put<Vendedor>(`${this.url}/${id}`, obj);
  }  

  pesquisar(search: string): Observable<Vendedor[]> {
    return this.http.get<Vendedor[]>(
      `${this.url}/nome/${search}`);
  }

  ativarDesativar(id: number, ativo: boolean = false): Observable<Vendedor> {
    return this.http.patch<Vendedor>(`${this.url}/${id}/ativo?ativo=${ativo}`, null as any);
  }
}
